import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonImg, IonMenuButton, IonPage, IonText, IonTitle, IonToolbar } from "@ionic/react";
import { addCircleOutline, logoWhatsapp, mapOutline, shareOutline } from "ionicons/icons";
import React from "react";
import usePWA from "react-pwa-install-prompt";
import MainTabBar from "../components/MainTabBar";

import "./Home.css";

const sendWhatsappMessage = (e: React.MouseEvent) => {
    e.preventDefault();
    window.location.href = "https://wa.me/393335889071?text=Ciao,%20vorrei%20ordinare%20";
    return null;
};

const Home: React.FC = () => {
    const { isStandalone, isInstallPromptSupported, promptInstall } = usePWA();

    const isIos = () => {
        const userAgent = window.navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod/.test(userAgent);
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton></IonMenuButton>
                    </IonButtons>
                    <IonTitle>Bar Gambero</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen forceOverscroll={true}>
                <IonHeader collapse="condense">
                    <IonToolbar>
                        <IonTitle size="large">Bar Gambero</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <div className="ion-padding">
                    <IonImg src={"assets/images/logo-bar-gambero.jpg"} style={{ padding: " 20px 10%" }} />
                    <p>
                        <strong>Per ordinare:</strong>
                    </p>
                    <IonButton color="light" fill="solid" size="large" expand="block" href="/menu">
                        <IonIcon slot="start" icon={mapOutline} />
                        Sfoglia il Menù
                    </IonButton>
                    <IonButton color="success" fill="solid" size="large" expand="block" onClick={(e) => sendWhatsappMessage(e)}>
                        <IonIcon slot="start" icon={logoWhatsapp} />
                        Scrivici su Whatsapp
                    </IonButton>
                    <IonText color="medium">
                        <small>
                            Specifica nome e numero del tavolo, oppure il tuo indirizzo per l'asporto.{" "}
                            <u>
                                <strong>Arriveremo direttamente da voi!</strong>
                            </u>
                        </small>
                    </IonText>
                    <p style={{ marginBottom: "50px" }}></p>
                    {/* <IonToolbar class="large-title-fix"></IonToolbar> */}
                </div>
                {isIos() && !isStandalone && (
                    <div className="ath-ios">
                        <h3>Installa l'App del Bar Gambero</h3>
                        <small>Installa questa app sul tuo cellulare per accedere velocemente ovunque ti trovi.</small>
                        <ul>
                            <div className="ath-step">
                                <IonIcon slot="start" icon={shareOutline} />
                                &nbsp;Tocca sul pulsante condividi
                            </div>
                            <div className="ath-step">
                                <IonIcon slot="start" icon={addCircleOutline} />
                                &nbsp;Seleziona "Aggiungi alla Home"
                            </div>
                            <div className="ath-step">Tocca su "Aggiungi"</div>
                        </ul>
                    </div>
                )}
            </IonContent>
            <MainTabBar />
        </IonPage>
    );
};

export default Home;
